import { Component, OnInit } from '@angular/core';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'shared/services/User/user.service';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { AppComponent } from 'app/app.component';
import { environment } from 'environments/environment';
import { LoginModelComponent } from './login-model/login-model.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.css']
})
export class ViewDetailsComponent implements OnInit {
  teamId: string;
  publicGroups: any;
  loading: boolean;
  groupId: any;
  publicGroup: any;
  code: string;
  state: string;
  isStripeConnected: boolean;
  imageURL: string = environment.URL_TEAM_IMAGES;
  user: any;
  chargeToken:any; 

  constructor(
    private groupService: GroupService,
    private alertService: AlertPopupService,
    private route: ActivatedRoute,
    private router: Router,
    private app: AppComponent,
    private payment: PaymentService,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    this.route.params.subscribe((params) => {
      this.groupId = params.groupId;
    });
  }
  //NOT IN USE 
  ngOnInit() {
    this.loading = true;
    this.user = JSON.parse(localStorage.getItem('SSUserCookie'));
    alert("Contact support.")
  }

  connectTeamAccount() {
   
  }

  proceed() {
    this.app.toggleLoadingMsg('Joining Group');
    const order_number = this.publicGroup.season_ticket.tm_order_num_out;
    const deposit_due = this.publicGroup.pre_auth_amount.new_deposit_due.toFixed(2);
    let promoCode; 
    this.payment.joinPublicGroup(this.chargeToken, order_number, this.groupId, deposit_due, promoCode).subscribe(res => {
      this.groupService.refreshGroup(this.groupId).subscribe(response => {
        this.app.dismissLoading();
        if(response.group_status == "PENDING_CONFIRM"){
          // tickets processing, custom group
          this.alertService.errorAlertSuccess("Your tickets are processing. Please allow 24-48 hours for them to appear in your Team Account. Keep an eye out for an email. ")
          this.router.navigate(['/groups']);
        } else {
          // regular group, move to get ready 
          this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: this.groupId } });
        }
      }, err => {
        this.app.dismissLoading();
        this.router.navigate(['/new-group']);
      });
    }, err => {
      this.app.dismissLoading();
      this.alertService.errorAlert('An error occured when trying to join this group. Contact support.');
    });
  }

  loginIn() {
    const login = this.dialog.open(LoginModelComponent, {
      width: '25%',
    });
    login.afterClosed().subscribe(res => {
      if (res) {
        this.alertService.errorAlertSuccess('Login Successfully');
        this.user = JSON.parse(localStorage.getItem('SSUserCookie'));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/widget/view-details/view-details.component.ts